/* LEGAL-NOTICE
   © Copyright 2018 - Quid Informatica S.p.A. - All Rights Reserved
   https://quidinfo.it/qinetic/licence.html - "Quid Consumer Lending Platform"
   Deposito SIAE n. 012702 del 26 Luglio 2018
LEGAL-NOTICE */
import { ModalController } from '@ionic/angular';
import { Component, OnInit } from '@angular/core';
import { AppService } from '@core/services/app/app.service';
import { HelpService } from '@services/help/help.service';
import { HelpLinks } from '@core/models';

@Component({
  selector: 'app-modal-state',
  templateUrl: './modal-state.component.html',
  styleUrls: ['./modal-state.component.scss']
})
export class ModalStateComponent implements OnInit {
  readonly helps: HelpLinks[] = ['faq', 'helpline', 'live_chat'];

  activeHelps: HelpLinks[] = [];

  logoUrl: string;

  constructor(
    private modalController: ModalController,
    private appService: AppService,
    public helpService: HelpService
  ) {}

  ngOnInit() {
    this.setHelpsActive();
    this.setLogoUrl();
  }

  async close(): Promise<void> {
    await this.modalController.dismiss();
  }

  private setHelpsActive(): void {
    this.activeHelps = this.helps.filter(code =>
      this.helpService.isLinkActive(code)
    );
  }

  private setLogoUrl(): void {
    this.logoUrl = this.appService.getConfig().theme.logoUrl;
  }
}
